import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Divider, List, Typography } from '@mui/material';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';
import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ item }) => {
  const theme = useTheme();
  const [permissionMatrix, setPermissionMatrix] = useState([]);

  const { accounts } = useMsal();

  useEffect(() => {
    if (localStorage.getItem(`UserPermissions`)) {
      setPermissionMatrix(JSON.parse(localStorage.getItem(`UserPermissions`)));
    }
  }, [item, accounts]);

  // menu list collapse & items
  const items = item.children?.map((menu) => {
    const permissionInfo = permissionMatrix.filter((x) => x.moduleId === menu.moduleId);

    switch (menu.type) {
      case 'collapse':
        return <NavCollapse key={menu.id} menu={menu} level={1} />;
      case 'item':
        // return permissionInfo && permissionInfo[0] && (permissionInfo[0].readRights === true || permissionInfo[0].writeRights === true) ? (
          return <NavItem key={menu.id} item={menu} level={1} />
        // ) : (
        //   <></>
        // );
      default:
        return (
          <Typography key={menu.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return (
    <>
      <List
        subheader={
          item.title && (
            <Typography variant="caption" sx={{ ...theme.typography.menuCaption }} display="block" gutterBottom>
              {item.title}
              {item.caption && (
                <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
                  {item.caption}
                </Typography>
              )}
            </Typography>
          )
        }
      >
        {items}
      </List>

      {/* group divider */}
      <Divider sx={{ mt: 0.25, mb: 1.25 }} />
    </>
  );
};

NavGroup.propTypes = {
  item: PropTypes.object
};

export default NavGroup;
